import {
  BOOKING_FORM_BILLING_FIELDS,
  BOOKING_FORM_CONTACT_FIELDS,
  BOOKING_FORM_FIELD_EMAIL_INSIDE,
  BOOKING_FORM_PERSON_FIELDS,
  BOOKING_FORM_TRAVELERS_CLEAN_PASSPORT_FIELDS,
} from "../../lib/constants";
import { isMobile } from "../../lib/isMobile";
import { getCleanFieldName } from "./getCleanFieldName";
import { getLoyaltyProgramsToPrefill } from "./getLoyaltyProgramsToPrefill";
import { prefillBookingSection } from "./prefillBookingSection";
import { prefillCbtTravelers } from "./prefillCbtTravelers";

export function getValueForField({
  fields,
  field,
  userDetail,
  cbtTravelersIds,
  cbt,
  previousBookingFormField,
  codeBook,
}) {
  const prefilledLoggedTraveler =
    (!cbtTravelersIds || cbtTravelersIds.length === 0) &&
    !cbt?.passengersForm.guests &&
    prefillLoggedTraveler({ fields, field, userDetail, codeBook });
  if (prefilledLoggedTraveler) {
    return prefilledLoggedTraveler;
  }

  const prefilledCbtTraveller =
    cbtTravelersIds &&
    cbtTravelersIds.length > 0 &&
    prefillCbtTravelers({ fields, field, cbtTravelersIds, cbt });

  if (prefilledCbtTraveller) {
    return prefilledCbtTraveller;
  }

  const prefilledContactInfo = prefillBookingSection({
    field,
    userDetail,
    bookingFormFields: BOOKING_FORM_CONTACT_FIELDS,
  });
  if (prefilledContactInfo) {
    return prefilledContactInfo;
  }

  const prefilledBillingInfo = prefillBookingSection({
    field,
    userDetail: {
      isLoggedIn: userDetail.isLoggedIn,
      ...userDetail.billingInfo,
    },
    bookingFormFields: BOOKING_FORM_BILLING_FIELDS,
  });
  if (prefilledBillingInfo) {
    return prefilledBillingInfo;
  }

  const prefilledEmptyEmail = prefillEmptyEmail(field);
  if (prefilledEmptyEmail) {
    return prefilledEmptyEmail;
  }

  const prefilledFreeBaggage = prefillFreeBaggage(field);
  if (prefilledFreeBaggage) {
    return prefilledFreeBaggage;
  }

  const prefilledFieldFromPreviousBookingForm = prefillFieldFromPreviousBookingForm(
    { previousBookingFormField }
  );

  if (prefilledFieldFromPreviousBookingForm) {
    return prefilledFieldFromPreviousBookingForm;
  }

  return field.defaultOptionValue || field.value || "";
}

function prefillLoggedTraveler({
  fields,
  field,
  field: { name },
  userDetail,
  codeBook,
}): string {
  if (!BOOKING_FORM_PERSON_FIELDS[name] || !userDetail?.isLoggedIn) {
    return "";
  }

  const { cleanFieldName } = getCleanFieldName(name);

  if (cleanFieldName === "frequent_flyer" && userDetail.loyalties?.length > 0) {
    return getLoyaltyProgramsToPrefill({
      fields,
      currentFieldName: name,
      userLoyaltyPrograms: userDetail.loyalties,
      availableLoyaltyPrograms: codeBook.LoyaltyPrograms?.Program,
    }).loyaltyProgramId;
  }

  if (
    cleanFieldName === "frequent_flyer_number" &&
    userDetail.loyalties?.length > 0
  ) {
    return getLoyaltyProgramsToPrefill({
      fields,
      currentFieldName: name,
      userLoyaltyPrograms: userDetail.loyalties,
      availableLoyaltyPrograms: codeBook.LoyaltyPrograms?.Program,
    }).loyaltyProgramMembershipId;
  }

  if (
    BOOKING_FORM_TRAVELERS_CLEAN_PASSPORT_FIELDS[cleanFieldName] &&
    userDetail.passports?.length > 0
  ) {
    return userDetail.passports[0][
      BOOKING_FORM_TRAVELERS_CLEAN_PASSPORT_FIELDS[cleanFieldName]
    ];
  }

  if (cleanFieldName === "title") {
    const titleValueFromApi = userDetail[BOOKING_FORM_PERSON_FIELDS[name]];
    const selectedOption = field.options.find(
      (option) => option.value.toLowerCase() === titleValueFromApi.toLowerCase()
    );

    return selectedOption?.value || "";
  }

  return userDetail[BOOKING_FORM_PERSON_FIELDS[name]];
}

function prefillEmptyEmail({ name }): string {
  if (!isMobile()) {
    return name?.includes(BOOKING_FORM_FIELD_EMAIL_INSIDE) ? "@" : "";
  }

  return "";
}

function prefillFreeBaggage(field) {
  if (
    !field.options ||
    field.options.length === 0 ||
    !(
      field.name.includes("LuggageOptions") ||
      field.name.includes("AncillaryOptions") ||
      field.name.includes("HandLuggage")
    )
  ) {
    return "";
  }

  const firstFreeBaggageOption = field.options.find(
    (option) => option?.data?.price === "0"
  );

  if (firstFreeBaggageOption) {
    return firstFreeBaggageOption.value;
  }

  return "";
}

function prefillFieldFromPreviousBookingForm({ previousBookingFormField }) {
  const { value, name } = previousBookingFormField || {};

  if (
    !value ||
    name.includes("frequent_flyer") ||
    name.includes("SeatOptions") ||
    name.includes("Luggage") ||
    name.includes("martkeplace") ||
    name.includes("AdvancedAncillaryOptions")
  ) {
    return "";
  }

  return value;
}
